import React, { useState } from "react";

export const SelectionJoursHoraires = ({ onSelectionChange }) => {
  const jours = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];

  // État global
  const [selection, setSelection] = useState(
    jours.reduce((acc, jour) => {
      acc[jour.toLowerCase()] = {
        selected: false,
        repasMidi: false,
        matin: false,
        apresMidi: false,
        horaires: {
          matinArrivee: "",
          matinDepart: "",
          apresMidiArrivee: "",
          apresMidiDepart: "",
        },
      };
      return acc;
    }, {})
  );

  // Plages horaires
  const morningOptions = ["07:30", "08:00", "08:30", "09:00"];
  const morningOptionsMidi = ["12:00", "12:30", "13:00",];
  const afternoonOptionsMidi = ["13:00", "13:30", "14:00"];
  const afternoonOptions = ["16:00", "16:30", "17:00", "17:30", "18:00", "18:30"];

  // Gérer les sélections
  const handleSelectionChange = (jour, field) => {
    setSelection((prev) => {
      const updatedSelection = {
        ...prev,
        [jour.toLowerCase()]: {
          ...prev[jour.toLowerCase()],
          [field]: !prev[jour.toLowerCase()][field],
        },
      };
      onSelectionChange && onSelectionChange(updatedSelection);
      return updatedSelection;
    });
  };

  // Gérer les horaires
  const handleTimeChange = (jour, period, type, value) => {
    setSelection((prev) => {
      const updatedSelection = {
        ...prev,
        [jour.toLowerCase()]: {
          ...prev[jour.toLowerCase()],
          horaires: {
            ...prev[jour.toLowerCase()].horaires,
            [period + type]: value,
          },
        },
      };
      onSelectionChange && onSelectionChange(updatedSelection);
      return updatedSelection;
    });
  };

  return (
    <div className="md:col-span-5 mt-5">
      <label className="block text-lg font-semibold text-gray-700 mb-2">
        Nombre de jours et d’heures d’accueil par semaine
        <p className="text-red-600 italic font-medium text-sm">
          (fonctionnement par forfait demi-journée et journée)
        </p>
      </label>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {jours.map((jour) => (
          <div key={jour} className="bg-white shadow-md rounded-lg p-4">
            {/* Sélection du jour */}
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                onChange={() => handleSelectionChange(jour, "selected")}
                checked={selection[jour.toLowerCase()].selected}
                className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <h3 className="text-md font-medium text-gray-800">{jour}</h3>
            </label>

            {/* Affichage des horaires si le jour est sélectionné */}
            {selection[jour.toLowerCase()].selected && (
              <div className="mt-3 space-y-3">
                {/* Matin */}
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    onChange={() => handleSelectionChange(jour, "matin")}
                    checked={selection[jour.toLowerCase()].matin}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Matin</span>
                </label>

                {/* Sélection des horaires Matin */}
                {selection[jour.toLowerCase()].matin && (
                  <div className="flex space-x-4">
                    <select
                      className="border border-gray-300 rounded-lg px-2 py-1 w-1/2 text-sm"
                      value={selection[jour.toLowerCase()].horaires.matinArrivee}
                      onChange={(e) => handleTimeChange(jour, "matin", "Arrivee", e.target.value)}
                    >
                      <option value="">Arrivée</option>
                      {morningOptions.map((time) => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>

                    <select
                      className={`border border-gray-300 rounded-lg px-2 py-1 w-1/2 text-sm ${selection[jour.toLowerCase()].repasMidi ? "bg-gray-200 cursor-not-allowed" : ""
                        }`}
                      value={selection[jour.toLowerCase()].horaires.matinDepart}
                      onChange={(e) => handleTimeChange(jour, "matin", "Depart", e.target.value)}
                      disabled={selection[jour.toLowerCase()].repasMidi}
                    >
                      <option value="">Départ</option>
                      {morningOptionsMidi.map((time) => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Repas midi */}
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    onChange={() => handleSelectionChange(jour, "repasMidi")}
                    checked={selection[jour.toLowerCase()].repasMidi}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Repas midi</span>
                </label>

                {/* Après-midi */}
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    onChange={() => handleSelectionChange(jour, "apresMidi")}
                    checked={selection[jour.toLowerCase()].apresMidi}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Après-midi</span>
                </label>

                {/* Sélection des horaires Après-midi */}
                {selection[jour.toLowerCase()].apresMidi && (
                  <div className="flex space-x-4">
                    <select
                      className={`border border-gray-300 rounded-lg px-2 py-1 w-1/2 text-sm ${selection[jour.toLowerCase()].repasMidi ? "bg-gray-200 cursor-not-allowed" : ""
                        }`}

                      value={selection[jour.toLowerCase()].horaires.apresMidiArrivee}
                      onChange={(e) => handleTimeChange(jour, "apresMidi", "Arrivee", e.target.value)}
                      disabled={selection[jour.toLowerCase()].repasMidi}

                    >
                      <option value="">Arrivée</option>
                      {afternoonOptionsMidi.map((time) => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>

                    <select
                      className="border border-gray-300 rounded-lg px-2 py-1 w-1/2 text-sm"
                      value={selection[jour.toLowerCase()].horaires.apresMidiDepart}
                      onChange={(e) => handleTimeChange(jour, "apresMidi", "Depart", e.target.value)}
                    >
                      <option value="">Départ</option>
                      {afternoonOptions.map((time) => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectionJoursHoraires;
